import { render, staticRenderFns } from "./OrderItem-gt3.vue?vue&type=template&id=e6a17ff0&scoped=true"
import script from "./OrderItem-gt3.vue?vue&type=script&lang=js"
export * from "./OrderItem-gt3.vue?vue&type=script&lang=js"
import style0 from "./OrderItem-gt3.vue?vue&type=style&index=0&id=e6a17ff0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6a17ff0",
  null
  
)

export default component.exports